module.exports = __webpack_public_path__ + "img/ETC.9a4150b6.svg";